import {GS1Parser} from '@valentynb/gs1-parser'

export const gs1Parser = new GS1Parser({
  // if not specified, the GS char is used
  fncChar: '~',
})
